import React, { useState, useCallback } from 'react';
import classNameBind from 'classnames/bind';
import styles from './List.module.css';

const bindClasses = classNameBind.bind(styles);

const List = ({ children }) => {
  const [topShadow, setTopShadow] = useState(false);
  const [bottomShadow, setBottomShadow] = useState(false);

  const calculateShadow = (target) => {
    if (typeof (target) !== 'undefined') {
      setTopShadow(!!target.scrollTop);
      setBottomShadow(target.scrollTop < (target.scrollHeight - target.clientHeight));
    }
  };

  const handleRef = useCallback((node) => {
    if (!node) return;
    const resizeObserver = new ResizeObserver((ref) => {
      calculateShadow(ref[0].target);
    });
    resizeObserver.observe(node);
  }, []);

  return (
    <div
      className={bindClasses('wrapper')}
      data-ppuc-id="Sidebar.List"
    >
      <div
        className={bindClasses('wrapper-inside', { topShadow, bottomShadow })}
        ref={handleRef}
        onScroll={(e) => { calculateShadow(e.target); }}
      >
        <div>
          { children }
        </div>
      </div>
    </div>
  );
};

export default List;
